import { FmvBarData, FmvPieData } from '../service/calculations-service/fair-value-and-pp-charts.service';
import {
  HighchartsOptions,
} from '../../../../shared/component/pie-chart-simple/highcharts-common/highcharts-global-const';
import { LocalDate } from "../../../../../core/pojo/date-variable";
import { ReportPasswordWrapper } from "../../../../investor-report/pojo/ir-common-classes";
import { DrilldownCompanyData } from '../../../../chart/ChartAuxiliary';

export class FmvChart {
  data: FmvChartsData;
  options: FmvChartsOptions = new FmvChartsOptions();
  extremum: FmvExtremum = new FmvExtremum();
}


export class FmvChartsData {
  fmv: FmvChartsFinData;
  investment: FmvChartsFinData;
}

export interface FmvChartsFinData {
  pieChart: FmvPieData;
  barChart: FmvBarData;
}

export class FmvChartsOptions {
  fmv: FmvChartOptionsTypes;
  investment: FmvChartOptionsTypes;
}

export class FmvExtremum {
  fmv = new FilterExtremum();
  investment = new FilterExtremum();
}

export class FilterExtremum {
  max = new PieChartCategory();
  min = new PieChartCategory();
}

export class FmvChartOptionsTypes {
  pieChart = new KrutoyChartType();
  barChart = new KrutoyChartType();
}

/*
 * If you have questions about this naming: ivan.zozulia@servc.co.il
 */
export class KrutoyChartType {
  byFund = new FmvChartsInformation();
  byCompany = new FmvChartsInformation();
  byIndustry = new FmvChartsInformation();
  byCountry = new FmvChartsInformation();
  byGroup = new FmvChartsInformation();
  byAssets = new FmvChartsInformation();
}

export class PieChartCategory {
  byFund = 0;
  byCompany = 0;
  byIndustry = 0;
  byCountry = 0;
  byGroup = 0;
  byAssets = 0;
}

export class FmvChartsPreData {
  fundUUID: string;
  period: Date;

  constructor(uuid: string, period: Date) {
    this.fundUUID = uuid;
    this.period = period;
  }
}

export class IrFmvChartsPreData {
  fundUUID: string;
  period: LocalDate;
  ppsList: number[];
  password: ReportPasswordWrapper;

  constructor(uuid: string, period: LocalDate, ppsList: number[], password: ReportPasswordWrapper) {
    this.fundUUID = uuid;
    this.period = period;
    this.ppsList = ppsList;
    this.password = password;
  }
}


export class FmvChartsInformation {
  chartId: string;
  additionalOptions: Partial<HighchartsOptions>;
}

export class FvAndPpChartsTableData {
  companyData: DrilldownCompanyData;
  cost: number;
  fairValue: number;
  gain: number;
  moic: number;
  pcntOfTotalCost: number;
  pcntOfTotalFmv: number;
}

export class DataBehindTable {
  body: FvAndPpChartsTableDataBody[] = [];
  total = new FvAndPpChartsTableData();
}

export interface GroupedPortfolioExcelWrapper {
  rawData: DataBehindTable;
  categoryName: string;
  drillDown?: FvAndPpChartsTableData[];
  isOnlyCompanies: boolean;
}
export interface FvAndPpChartsTableDataBody {
  type: FvAndPpChartsTableData; // category row data
  drilldown: FvAndPpChartsTableData[]; // company rows data
}

export const DATA_BEHIND_SORT = {
  byName: (dataBehind: FvAndPpChartsTableDataBody): string => dataBehind.type.companyData.name,
  byCost: (dataBehind: FvAndPpChartsTableDataBody): number => dataBehind.type.cost,
  byFmv: (dataBehind: FvAndPpChartsTableDataBody): number => dataBehind.type.fairValue,
  byGainLoss: (dataBehind: FvAndPpChartsTableDataBody): number => dataBehind.type.gain,
  byMoic: (dataBehind: FvAndPpChartsTableDataBody): number => dataBehind.type.moic,
  byPcntTotalCost: (dataBehind: FvAndPpChartsTableDataBody): number => dataBehind.type.pcntOfTotalCost,
  byPcntTotalFmv: (dataBehind: FvAndPpChartsTableDataBody): number => dataBehind.type.pcntOfTotalFmv,
};

export const DATA_BEHIND_COMPANIES_SORT = {
  byName: (data: FvAndPpChartsTableData): string => data.companyData.name,
  byCost: (data: FvAndPpChartsTableData): number => data.cost,
  byFmv: (data: FvAndPpChartsTableData): number => data.fairValue,
  byGainLoss: (data: FvAndPpChartsTableData): number => data.gain,
  byMoic: (data: FvAndPpChartsTableData): number => data.moic,
  byPcntTotalCost: (data: FvAndPpChartsTableData): number => data.pcntOfTotalCost,
  byPcntTotalFmv: (data: FvAndPpChartsTableData): number => data.pcntOfTotalFmv,
};
